/* eslint-disable react/no-array-index-key */
/* eslint-disable no-mixed-operators */
/* eslint-disable camelcase */

import React from 'react';
import moment from 'moment';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import parsfixed from 'utils/values/parsfixed.util';

import EmailClient from './EmailClient';

const Email = ({ depositRefunded, salonDetails }) => {
  const { t } = useTranslation();

  if (!depositRefunded) return <h2 data-bem="Email--loading">{t('balanceSheet.emailReceipt.loadingData')}</h2>;

  const imgSrc = salonDetails && salonDetails.profile_image ? salonDetails.profile_image : null;
  const sImg = {
    borderRadius: '38px',
    mozBorderRadius: '38px',
    display: 'block',
    margin: ' 0 auto',
    border: '1px solid #f1f1f1',
    marginTop: '17px',
    height: '120px',
  };

  const table = {
    borderollapse: 'collapse',
    width: '100%',
    height: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Open Sans,sans-serif',
  };

  const s9 = {
    backgroundColor: '#fff',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
    // gmail test
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };
  const s10 = {
    backgroundColor: '#fff',
    borderBottom: '1px solid #e5e5e5',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '24px',
    fontFamily: 'Open Sans,sans-serif',
    fontWeight: 600,
    // gmail test
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };
  const s11 = {
    fontSize: '18px',
    color: '#6b6d6f',
    fontWeight: 100,
    marginBottom: '3px',
    margiTnop: '0',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s12 = {
    fontSize: '24px',
    fontFamily: 'Open Sans,sans-serif',
    marginBottom: '12px',
    marginTop: '0',
  };
  const s13 = {
    whiteSpace: 'nowrap',
    backgroundColor: '#fff',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
    height: '36px',
    // gmail test
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };
  const s14 = {
    marginLeft: ' 42px',
    textAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s15 = {
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s16 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
    marginRight: '48px',
  };

  const s32 = {
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
    // gmail test
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };

  const s36 = {
    marginTop: '4px',
    marginBottom: '6px',
    marginRight: '48px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s37 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
  };

  const s39 = {
    marginTop: '4px',
    marginBootom: '4px',
    marginLeft: '42px',
    color: ' #3e0b6c',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s40 = {
    borderBottom: '1px solid #e5e5e5',
    marginBootom: '30px',
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s41 = {
    marginBootom: '0',
    marginTop: '0',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    marginRight: '46px',
  };
  const s44 = {
    borderBottom: '1px solid #e5e5e5',
    marginBootom: '30px',
    backgroundColor: '#fff',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };

  const bgr = {
    backgroundColor: '#e5e5e5',
    fontFamily: 'Open Sans,sans-serif',
    position: 'relative',
    zIndex: 3000,
    minHeight: '980px',
  };

  const date = moment().format('DD MMMM YYYY');

  return (
    <div data-bem="Email--recepit" style={bgr} id="receipt">
      <table className="body" style={table}>
        <tbody>
          <tr>
            <td className="center" style={{ textAlign: 'center', verticalAlign: 'top' }}>
              <center>
                <div>
                  <table cellPadding="10" cellSpacing="0" style={table}>
                    <tbody>
                      <tr>
                        <td colSpan="2" style={s9}>
                          {imgSrc && imgSrc.length > 400 ? <br /> : imgSrc && <img src={imgSrc} height="120" alt="Salon" style={sImg} />}
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="2" style={s10}>
                          <p style={s11}>{t('balanceSheet.emailReceipt.refundReceiptFrom')}</p>
                          {salonDetails && <h3 style={s12}>{salonDetails.name}</h3>}
                        </td>
                      </tr>
                      <tr>
                        <td height="40" style={s13}>
                          <h2 style={s14}> {t('balanceSheet.emailReceipt.refundDate')}</h2>
                        </td>
                        <td style={s15}>
                          <p style={s16}>{date}</p>
                        </td>
                      </tr>

                      <EmailClient
                        tableStyle={table}
                        client={{ client: 'hello' }}
                        amount={
                          <>
                            <CurrencySign />
                            {parsfixed(Math.abs(depositRefunded.amount))}
                          </>
                        }
                      />

                      <tr>
                        <td style={s32} colSpan="2">
                          <p style={s36}>
                            <span style={s37}>{t('balanceSheet.emailReceipt.refund')} </span>
                            <span style={s37}>
                              <CurrencySign />
                              {Math.abs(parsfixed(depositRefunded.amount))}
                            </span>
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td style={s44}>
                          <p style={s39} />
                        </td>
                        <td style={s40}>
                          <p style={s41} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </center>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Email;
